module.exports = __webpack_public_path__ + "img/error.f61dcb97.svg";